<template>
  <v-card class="pa-6 elevation-1">
    <v-card-title class="text-uppercase">Cấu hình Điểm chuẩn</v-card-title>
    <v-divider />
    <v-card-text>
      <div v-if="canViewA">
        <div class="mb-3 text-h5">Cơ sở A - Cầu Giấy</div>
        <div class="config-row">
          <config-section department="Cơ sở A" grade="Khối 10" type="enroll" />
          <config-section department="Cơ sở A" grade="Khối 10" type="reserve" />
        </div>
      </div>
      <v-divider class="my-6" v-if="canViewA && canView1" />
      <div v-if="canView1">
        <div class="mb-3 text-h5">Cơ sở 1 - Tân Triều</div>
        <div class="config-row">
          <config-section department="Cơ sở 1" grade="Khối 10" type="enroll" />
          <config-section department="Cơ sở 1" grade="Khối 10" type="reserve" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import ConfigSection from './ConfigSection.vue'
export default {
  components: {ConfigSection},
  computed: {
    ...mapGetters('auth', ['user']),
    type() {
      return this.$helpers.CV_DEADLINE_TYPE.RESULT_FILL
    },
    userDepartment() {
      return get(this.user, 'department', '')
    },
    canViewA() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở A'
    },
    canView1() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở 1'
    },
  },
  methods: {...mapActions({fetchItems: 'enrollCutoffMark/fetchItems'})},
  async mounted() {
    await this.fetchItems({type: this.type})
  },
}
</script>
<style lang="scss" scoped>
.config-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 0px;
}
.config-section {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
}
</style>